<template>
  <div
    class="widget-header mb-4 flex w-full justify-center bg-primary-500 py-4"
  >
    <UiContainer>
      <div class="flex items-center justify-between gap-2 px-5 sm:flex-wrap">
        <div class="flex w-3/4 items-center sm:w-full">
          <div v-if="withBackButton" class="mr-3">
            <UiButton
              class="!bg-transparent py-1.5 pl-4 font-medium sm:items-start sm:pl-0"
              @click="goBack"
            >
              <UiIcon name="outline/chevron-left" class="size-5" />
            </UiButton>
          </div>
          <div class="pr-4 sm:w-full sm:items-start">
            <h1
              v-if="isInitialized"
              class="widget-header__title text-xl font-bold"
            >
              <slot name="title" />
            </h1>
            <div v-else>
              <UiSkeleton class="w-30 mb-2 h-6" />
            </div>
          </div>
        </div>
        <div
          class="flex justify-end text-right sm:w-full sm:justify-start sm:text-left"
          :class="{ 'pl-14': withBackButton }"
        >
          <slot name="info" />
        </div>
      </div>
    </UiContainer>
  </div>
</template>

<script setup lang="ts">
import { useWidgetEnvironment } from '~/widget/composables/useWidgetEnvironment'

defineProps({
  withBackButton: Boolean,
})
const route = useRoute()
const router = useRouter()

const fallbackRoute = '/' // или name: 'Home'
const from = (route.query.from as string) || fallbackRoute

const goBack = () => {
  router.push(from)
}

const { isInitialized } = useWidgetEnvironment()
</script>
